// const BaseApi = "https://sportsjobfinder.logicspice.com/job-board-script/api"
const BaseApi = "https://www.sportsjobfinder.com/job-board-script/api"

export default BaseApi
